import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";

import { LanguageProvider } from "./LanguageContext";
import { AuthProvider } from "./AuthContext";
import Layout from "./components/Layout";

import Home from "./pages/Home";
import Comprendre from "./pages/Comprendre";
import Inscrire from "./pages/Inscrire";
import SEngager from "./pages/SEngager";
import Pratique from "./pages/Pratique";
import Actualites from "./pages/Actualites";
import ActualiteDetail from "./pages/ActualiteDetail";
import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import Don from "./pages/Don";
import SetPassword from "./pages/SetPassword";
import Formation from "./pages/Formation";
import Team from "./pages/Team";
import EspaceMembres from "./pages/EspaceMembres";
import MentionsLegales from "./pages/MentionsLegales";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tmo = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(tmo);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function ImageProtection() {
  useEffect(() => {
    const blockContextMenu = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };
    const blockDragStart = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };
    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("dragstart", blockDragStart);
    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("dragstart", blockDragStart);
    };
  }, []);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ImageProtection />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/comprendre" element={<Comprendre />} />
              <Route path="/inscrire" element={<Inscrire />} />
              <Route path="/s-engager" element={<SEngager />} />
              <Route path="/immersions" element={<Navigate to="/s-engager" replace />} />
              <Route path="/pratique" element={<Pratique />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/actualites/:id" element={<ActualiteDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/formation" element={<Formation />} />
              <Route path="/equipe" element={<Team />} />
              <Route path="/temoignages" element={<Testimonials />} />
              <Route path="/don" element={<Don />} />
              <Route path="/espace-membres" element={<EspaceMembres />} />
              <Route path="/definir-mot-de-passe" element={<SetPassword />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
